<template>
    <div>
        <div class="row edit-row">
            <div class="col-xs-10 row-title">捐助我们</div>
            <div class="col-xs-2">
                <i class="iconfont icon-plus-circle-fill" @click="moreDonate"></i>
            </div>
        </div>
        <div class="row">
            <el-carousel indicator-position="outside">
                <el-carousel-item v-for="pay in data.pays">
                    <div class="pay-msg">
                        <img :src="pay.url" @click="moreDonate">
                        <div class="carousel-msg" v-text="'￥'+pay.amount + '（'+ pay.name +'）'"></div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <marquee id="donates-info" direction='up' align="middle" onmouseover=stop() onmouseout=start() scrolldelay="1000" scrollamount="10">
            <div v-for="(donate,index) in data.donates" v-text='"感谢【" + donate.user_name + "】于" + donate.created_at  + "捐献 " + donate.amount  + "元；"'>
            </div>
        </marquee>
        <hr />
        <el-dialog v-model="data.dialog_visible" title="捐助我们" width="30vw">
            <div id="donate-more" class="container-fluid">
                <div class="donate-row pay-msg">
                    <div v-if="data.platform != 'ali'">
                        <img :src="data.pays.wx.url">
                        <div class="carousel-msg" v-text="'￥'+ data.pays.wx.amount +'（微信）'"></div>
                    </div>
                    <div v-else-if="data.platform == 'ali'">
                        <img :src="data.pays.ali.url">
                        <div class="carousel-msg" v-text="'￥'+ data.pays.ali.amount +'（支付宝）'"></div>
                    </div>
                </div>
                <div class="donate-row donate-radio-row">
                    <el-form-item>
                        <el-radio-group v-model="data.platform">
                            <el-radio label="wx">微信</el-radio>
                            <el-radio label="ali">支付宝</el-radio>
                        </el-radio-group>
                    </el-form-item> 
                </div>                   
                <div class="donate-row donate-input-row">
                    <el-input v-if="data.platform != 'ali'" v-model="data.pays.wx.input_amount"  placeholder="金额（￥）"/>
                    <el-input v-else-if="data.platform == 'ali'" v-model="data.pays.ali.input_amount"  placeholder="金额（￥）"/>
                </div>
                <div class="donate-row">
                    <div class="btn btn-primary login-submit" @click="getPayQRCode">获取二维码</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script src="./donate.vue.js"></script>
<style scoped>
.pay-msg{
    text-align: center;
}
.pay-msg img{
    width: 60%;
    cursor: pointer;
    min-height: 240px;
}
.edit-row .icon-plus-circle-fill{
    top: 12px;
    position: relative;
}
#donates-info
{
	height: 30px;
	cursor: pointer;
}
#donates-info div
{
	height:30px;
	line-height:30px;
}
#donate-more{
    text-align: center;
    padding: 0 50px 50px 50px;
}
#donate-more .pay-msg img{
    width: 80%;
}
#donate-more .donate-row{
	margin-top: 30px;
    padding: 0 10%;
}
#donate-more .pay-msg{
    margin-top: 0;
}
#donate-more .donate-radio-row{
    display: -webkit-inline-box;
    margin-top: 10px;
}
#donate-more .donate-input-row{
	margin-top: 0;
}
#donate-more .el-input__wrapper
{
    width: 80%;
}
#donate-more .login-submit
{
    margin: auto;
    width: 100%;
}
</style>